<template>
  <v-fade-transition>
    <v-app class="theme--dark" v-show="value">
      <div class="hero-container">
          <v-img src='/static/img/report/hero.jpg'                
          aspect-ratio="1.7"
          gradient="to bottom right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, .7)"
          >                                                                                          
          </v-img>    
      </div>
      <div class="modal">
        <v-dialog 
        :value="value" 
        @input="$emit('input')" 
        max-width="500px"
        :open-delay="10000"
        persistent>
          <v-form @submit.prevent="submit" ref="passcodeForm">
            <v-card>
              <v-toolbar
                color="primary"
                dark
                class="text-h5"
              ><v-icon class="mr-2">mdi-lock</v-icon> Enter Passcode</v-toolbar>
              <v-card-text class="pt-7">
                <v-fade-transition>
                  <v-alert type="error" dense v-if="invalid">
                    {{errText}}
                  </v-alert>
                </v-fade-transition>
                <v-text-field
                  prepend-icon="security"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'" label="Passcode"
                  v-model="passcode"
                  @keydown.space.prevent 
                  @input="removeSpaces" 
                  @paste="preventPasteSpaces" 
                  :error-messages="passcodeErrors"
                  @click:append="show1 = !show1" 
                  @blur="$v.passcode.$touch()"
                  @keyup="invalid=false"
                ></v-text-field>
              </v-card-text>
              <v-card-actions class="justify-end pb-5">
                <v-btn
                  color="secondary"
                  type="submit"
                  :disabled="submitting"
                >
                <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>
    </v-app>
  </v-fade-transition>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';
import campaignAPIs from '../views/Campaign/campaignAPIs'
export default {
  name: 'ReportLoginModal',
  mixins: [validationMixin],
  props: {
    value: Boolean,
    campaignID: String
  },
  validations: {
    passcode: {
      required
    }
  },
  data() {
    return {
      show1: false,
      passcode: '',
      submitting: false,
      invalid: false,
      errText: ''
    }
  },
  computed: {
    passcodeErrors() {
      const errors = [];
      if (!this.$v.passcode.$dirty) return errors;
      !this.$v.passcode.required && errors.push('passcode is required');
      return errors;
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) { return false }

      const passcode = this.passcode
      this.submitting = true
      return campaignAPIs
      .loginCampaignReport(this.campaignID, passcode)
      .then(response => {
        this.submitting = false
        if (response.success) {
          this.$emit('loggedIn', passcode)
          return
        }

        this.invalid = true
        this.errText = response.message || 'Incorrect passcode. Please try again.'
      })
      .catch(error => {
        this.submitting = false
        this.invalid = true
        this.errText = (error.response && error.response.data && error.response.data.message) || 'Unable to verify the passcode. Please try again.'
        console.error(error);
      });
    },
    close() {
      this.$emit('input');
    },
    // Remove spaces after input (to clear spaces if pasted somehow)
    removeSpaces() {
      this.$v.passcode.$touch()
      this.passcode = this.passcode.replace(/\s/g, '');
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReportLoginModal.vue?d9b10134